import React from "react";
import { Layout, Breadcrumb, Row, Col, Popover, Popconfirm, Icon } from "antd";
import { Link } from "react-router-dom";
import { removeLoginInfo } from "../../utils/token";
import { withRouter } from "react-router-dom";
import { logout } from "../../api/login";
const { Header } = Layout;
const content = (
  <div>
    <Link style={{ color: "#000" }} to="/useraccount">
      账号
    </Link>
    <p>登出</p>
  </div>
);
class Headers extends React.Component {
  render() {
    return (
      <Header style={{ background: "#fff", padding: "0 20px" }}>
        <Row>
          <Col span={12}>
            <Breadcrumb style={{ marginTop: 20 }}>
              {this.props.BreadCrumbData.map((item, index) => {
                return index === this.props.BreadCrumbData.length - 1 ? (
                  <Breadcrumb.Item key={item.path}>{item.name}</Breadcrumb.Item>
                ) : (
                  <Breadcrumb.Item key={item.path}>
                    <a href={item.path}>{item.name}</a>
                  </Breadcrumb.Item>
                );
              })}
            </Breadcrumb>
          </Col>
          <Col span={12} align="right">
            <div style={{ height: 64, lineHeight: "64px" }}>
              <div>
                <span
                  style={{
                    width: 200,
                  }}
                >
                  {JSON.parse(sessionStorage.getItem("loginInfo")).companyName}
                </span>
                <Popover
                  placement="bottomRight"
                  content={
                    <div style={{ width: 70, textAlign: "center" }}>
                      <Link
                        style={{
                          color: "#000",
                          height: 30,
                          lineHeight: "30px",
                        }}
                        to="/page/useraccount"
                      >
                        账号
                      </Link>
                      <p
                        onClick={() => {
                          logout().then((res) => {
                            if (res.success) {
                              removeLoginInfo();
                              this.props.history.push("/login");
                            }
                          });
                        }}
                        style={{
                          cursor: "pointer",
                          height: 30,
                          lineHeight: "30px",
                          marginBottom: 0,
                        }}
                      >
                        登出
                      </p>
                    </div>
                  }
                  trigger="click"
                >
                  <span style={{ cursor: "pointer" }}>
                    <span
                      style={{
                        margin: "0 10px",
                        width: 200,
                      }}
                    >
                      {JSON.parse(sessionStorage.getItem("loginInfo")).name}
                    </span>
                    <Icon
                      type="caret-down"
                      style={{ color: "#D8D8D8", fontSize: 12 }}
                    />
                  </span>
                </Popover>
              </div>
            </div>
          </Col>
        </Row>
      </Header>
    );
  }
}
export default withRouter(Headers);
